import secureLocalStorage from "react-secure-storage";

const listeners = new Set();

const inferStoredAccountType = () => {
  const storedType = secureLocalStorage.getItem("authType");
  if (storedType === "admin" || storedType === "partner") return storedType;

  const role = secureLocalStorage.getItem("role");
  if (
    role === "super user" ||
    role === "support" ||
    role === "relationship manager"
  ) {
    return "admin";
  }

  if (
    role === "hospital" ||
    role === "company" ||
    role === "agency" ||
    role === "individual"
  ) {
    return "partner";
  }

  return null;
};

const hasStoredSessionHint =
  secureLocalStorage.getItem("isAuth") === true &&
  inferStoredAccountType() !== null;

let authenticationSession = {
  status: hasStoredSessionHint ? "loading" : "anonymous",
  token: null,
  expiresIn: null,
  id: secureLocalStorage.getItem("id") || null,
  role: secureLocalStorage.getItem("role") || null,
  accountType: inferStoredAccountType(),
};

const emitChange = () => listeners.forEach((listener) => listener());

export const subscribeToAuthentication = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const getAuthenticationSession = () => authenticationSession;
export const getStoredAccountType = () =>
  authenticationSession.accountType || inferStoredAccountType();

export const setAuthenticationLoading = () => {
  authenticationSession = {
    ...authenticationSession,
    status: "loading",
  };
  emitChange();
};

export const setAuthenticationSession = ({
  token,
  expiresIn,
  id,
  role,
  accountType,
}) => {
  authenticationSession = {
    status: "authenticated",
    token,
    expiresIn: Number(expiresIn),
    id,
    role,
    accountType,
  };

  secureLocalStorage.removeItem("token");
  secureLocalStorage.removeItem("expiresIn");
  secureLocalStorage.removeItem("refreshToken");
  secureLocalStorage.removeItem("refreshTokenExpiresIn");
  secureLocalStorage.setItem("isAuth", true);
  secureLocalStorage.setItem("id", String(id));
  secureLocalStorage.setItem("role", role);
  secureLocalStorage.setItem("authType", accountType);
  secureLocalStorage.setItem(
    "login",
    accountType === "admin" ? "adminside" : "partnerside",
  );

  window.dispatchEvent(new Event("authUpdate"));
  emitChange();
};

export const clearAuthenticationSession = () => {
  authenticationSession = {
    status: "anonymous",
    token: null,
    expiresIn: null,
    id: null,
    role: null,
    accountType: null,
  };

  secureLocalStorage.clear();
  localStorage.clear();
  window.dispatchEvent(new Event("authUpdate"));
  emitChange();
};
